import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-logged-in-header',
  templateUrl: './logged-in-header.component.html',
  styleUrls: ['./logged-in-header.component.scss']
})
export class LoggedInHeaderComponent implements OnInit {
  userName: string = "";
  constructor(private userService: UserService,
    private router: Router) {
    this.userName = this.userService.readUserObject.userName;
  }

  ngOnInit() {
  }
  public logOut(): void {
    this.userService.logout();
  }

  changepassword() {
    this.router.navigate(['change-password']);
  }
}
